import { render, staticRenderFns } from "./ReceivedMonthInsurer.vue?vue&type=template&id=6a01df28"
import script from "./ReceivedMonthInsurer.vue?vue&type=script&lang=js"
export * from "./ReceivedMonthInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports